// third-party
import { combineReducers } from 'redux';

// project imports
import snackbarReducer from './slices/snackbar';
import drawerReducer from './slices/drawer';
// import projectApiSlice from './slices/apis/projectApiSlice';
import { apiSlice } from './slices/apis/apiSlice';
// ==============================|| COMBINE REDUCER ||============================== //


const reducer = combineReducers({
    snackbar: snackbarReducer,
    drawer: drawerReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    // [projectApiSlice.reducerPath]: projectApiSlice.reducer,
});
export default reducer;
